import ComponentName from '@Constant/componentName'
import { DMP } from '@Constant/behaviorTrack'

const crowd = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/crowd',
    redirect: {
      name: ComponentName.crowd.index
    },
    children: [
      {
        component: () => import('../../views/crowd/index.vue'),
        path: 'index',
        name: ComponentName.crowd.index,
        auth: '*',
        meta: {
          title: '人群包选人',
          logAuto: {
            pv: true,
            duration: true,
            source: DMP.PV
          }
        }
      }
    ]
  }
]

export default crowd
